import React, { useState, useEffect } from 'react';
import './ProductCreationDemo.css';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import supportData from './supportData'; // Import the shared data

export default function ProductCreationDemo() {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const { creationSlug } = useParams(); // Get the slug from the URL

    // Try to get steps from location.state first (for initial navigation from Support.js)
    let steps = location.state?.steps;

    // If steps are not found in state (e.g., on direct URL access or refresh),
    // look them up using the creationSlug from the URL.
    if (!steps || steps.length === 0) {
        const foundItem = supportData.find(item => item.slug === creationSlug);
        if (foundItem) {
            steps = foundItem.steps;
        } else {
            steps = []; // Fallback to empty array if no matching slug is found
        }
    }

    // You can still log the slug for debugging if needed
    useEffect(() => {
        console.log("ProductCreationDemo: Current creation slug from URL:", creationSlug);
        console.log("ProductCreationDemo: Steps determined:", steps);
    }, [creationSlug, steps]); // Re-run if slug or steps change

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const Done = () => {
        navigate('/Support');
    };

    return (
        <div className="product-creation-demo">
            <div className="image-container">
                {steps.length > 0 ? (
                    <>
                        <img
                            src={steps[currentStep].image}
                            alt="Step Image"
                        />
                        <div className="message-box">
                            <p>{steps[currentStep].message}</p>
                            {currentStep < steps.length - 1 ? (
                                <button
                                    className="next-button"
                                    onClick={handleNext}
                                >
                                    Next
                                </button>
                            ) : (
                                <button
                                    className="next-button"
                                    onClick={Done}
                                >
                                    Done
                                </button>
                            )}
                        </div>
                    </>
                ) : (
                    <p>No steps found for "{creationSlug}".</p> // More descriptive message
                )}
            </div>
        </div>
    );
}